module.exports = __webpack_public_path__ + "img/ntp-server-icon.dd9c7a9e.png";